export const TYPE_STYLES = {
  admin: {
    color: "#147AD6",
    borderColor: "#147AD6",
    backgroundColor: "#EDF5FC"
  },
  user: {
    color: "#147AD6",
    borderColor: "#147AD6",
    backgroundColor: "#EDF5FC"
  },
  manager: {
    color: "#3F9142",
    borderColor: "#3F9142",
    backgroundColor: "#F0F7F0"
  },
  standard: {
    color: "#E9A30C",
    borderColor: "#E9A30C",
    backgroundColor: "#FEF8EC"
  },
  Yes: {
    color: "#3F9142",
    borderColor: "#3F9142",
    backgroundColor: "#F0F7F0"
  },
  No: {
    color: "#C62828",
    borderColor: "#C62828",
    backgroundColor: "#EFE3E3"
  }
};
